import {
  TableCellProps,
  WbTableWithFilters,
  useTruncatedStyles,
} from '@agilelab/plugin-wb-platform';
import { PermissionDetail } from '@agilelab/plugin-wb-rbac-common';
import { useRoleDrawerContext } from '../Context/RoleDrawerTableContext';

const useTableColumnSpecs = (): Array<TableCellProps<PermissionDetail>> => {
  const truncatedClass = useTruncatedStyles({});

  return [
    {
      field: 'subjectdisplayname',
      tooltip: true,
      width: '20%',
      typographyProps: {
        component: 'p',
        className: truncatedClass.truncated,
      },
      headerName: 'Subject',
    },
    {
      field: 'display_name',
      tooltip: true,
      width: '20%',
      typographyProps: {
        component: 'p',
        className: truncatedClass.truncated,
      },
      headerName: 'Role',
    },
    {
      field: 'description',
      tooltip: true,
      width: '20%',
      typographyProps: {
        component: 'p',
        className: truncatedClass.truncated,
      },
      headerName: 'Description',
    },
  ];
};

export const RolesDrawerTable = () => {
  const {
    permissions,
    setPagination,
    pagination,
    permissionCount,
    filters,
    changeFilters,
  } = useRoleDrawerContext();

  return (
    <WbTableWithFilters<PermissionDetail>
      containerStyle={{
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
      }}
      filters={{
        searchValue: filters.text || '',
        onSearchChange: (search: string) => {
          changeFilters('text', search);
        },
        activeFilters: 0,
        onFiltersClick: () => {},
        show: false,
      }}
      table={{
        components: {
          tableLoader: { loading: false },
          tableContent: {
            columns: useTableColumnSpecs(),
            rows: permissions,
          },
        },
        pagination: {
          count: permissionCount || 0,
          limit: pagination.limit,
          offset: pagination.offset,
          onPageChange: (page: number) => {
            setPagination({
              ...pagination,
              offset: page * pagination.limit,
            });
          },
          onRowsPerPageChange: (rowsPerPage: number) => {
            setPagination({
              offset: 0,
              limit: rowsPerPage,
            });
          },
        },
      }}
    />
  );
};
